module.exports = __webpack_public_path__ + "static/media/list.f08cd00f.svg";